import { Typography } from '@mui/material';
import { BuyerAgreementDropzoneWidthFileListField } from '@/components/BuyerAgreementDropzoneWithFileList/BuyerAgreementDropzoneWithFileListField';

export const BuyerAgreementAttachmentSection = () => {
  return (
    <>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        The signed buyer agreement will be attached to this Offer and your newly
        created Buyer. You’ll have the opportunity to send more documents once
        the Offer is created.
      </Typography>
      <BuyerAgreementDropzoneWidthFileListField />
    </>
  );
};
